import { trackCheckoutSummaryDetails } from '@ecomm/cdp-tracking'
import { useCartDiscountCode, useCartLineItems } from '@ecomm/data-cart'
import { ChevronDown } from '@ecomm/shared-icons'
import { useTrackingSummaryDetails } from '@ecomm/tracking'

import classNames from 'classnames'
import { useState } from 'react'

import { Item } from './Item'
import { Totals } from './Totals'
import { generateRowSummary } from './generateRowSummary'

export function Summary() {
  const trackingSummaryDetails = useTrackingSummaryDetails()
  const [open, setOpen] = useState(false)

  const lineItems = useCartLineItems()
  const discountCode = useCartDiscountCode()

  const handleExpand = () => {
    const accordionState = !open ? 'expand' : 'collapse'
    trackingSummaryDetails(accordionState)
    trackCheckoutSummaryDetails(accordionState)
    setOpen(!open)
  }

  return (
    <div
      className="rounded-base bg-neutral-light-50 mx-auto mb-8 p-6 md:mb-16"
      data-component="OrderSummary"
      data-testid="OrderSummary"
    >
      <div className="flex flex-col">
        <button
          className="flex bg-neutral-light-50 cursor-pointer items-center justify-between border-0 p-0"
          onClick={handleExpand}
        >
          <h4 className="text-neutral-black m-0 mb-1 text-base font-bold md:mb-0 md:text-lg">
            Review cart
          </h4>
          <ChevronDown
            className={classNames('text-complementary-blue-100 h-8 w-8', {
              'rotate-180': open
            })}
          />
        </button>
        <div
          className="text-neutral-black text-left text-sm"
          data-component="RowSummary"
        >
          {generateRowSummary(lineItems, !!discountCode)}
        </div>
        <div
          className={classNames(
            'mb-0 transition-[height] duration-1000 ease-out',
            { 'h-0': !open },
            { '-mb-4 h-4': open }
          )}
        />
        <div
          aria-hidden={!open}
          aria-labelledby="OrderSummaryAccordionHeading"
          className={classNames({ hidden: !open })}
          data-component="OrderSummaryAccordionHeading"
          role="region"
        >
          {lineItems.map((lineItem, index) => (
            <Item key={index} {...lineItem} />
          ))}
        </div>
      </div>
      <Totals />
    </div>
  )
}
